import React from 'react';
//import PropTypes from 'prop-types';
//import WebApp from '@twa-dev/sdk';
import Background from 'components/common/Background';
import corner4 from 'assets/img/illustrations/corner-4.png';
import Input from 'components/common/Input';
import Flex from 'components/common/Flex';
import Avatar from 'components/common/Avatar';
import IconAlert from 'components/common/IconAlert';
//import SimpleBarReact from 'simplebar-react';

import { Card, Col, Collapse, Form, Row } from 'react-bootstrap';
import IconButton from 'components/common/IconButton';
import useTelegram from '../useTelegram';
import classNames from 'classnames';

const New = () => {
 const { watch, register, handleSubmit, errors, setValue, onError, onSubmitData, select, setSelect } = useTelegram();
 const [isExpanded, setIsExpanded] = React.useState({ envelope: false, box: false });
 const createOption = inputValue => {
  const newOption = { label: inputValue, value: inputValue };
  setValue('amenities', [...select.amenities.map(e => e.value), inputValue]);
  setSelect(prev => ({ ...prev, options: [...prev.options, newOption] }));
 };

 //  style={{ position: 'fixed', bottom: 0, left: 0, right: 0 }}
 // style={{ height: 'var(--tg-viewport-stable-height, 100vh)', pointerEvents: 'none', transition: 'all 0.1s ease' }}

 /* useEffect(() => {
  console.log(WebApp, 'se monto el componente');
  WebApp.onEvent('expand', e => console.log(e, 'se expandio'));
 }, []); */

 return (
  <Form noValidate onSubmit={handleSubmit(onSubmitData, onError)}>
   <div className={classNames('d-grid gap-2 p-3 fixed-bottom')}>
    <IconButton variant="falcon-primary" type="submit" icon="tags" iconAlign="right" transform="down-1 shrink-4">
     Guardar
    </IconButton>
   </div>

   <Card className="bg-transparent border m-3 mt-6">
    <Background
     image={corner4}
     className="bg-card"
     style={{
      borderTopRightRadius: '0.375rem',
      borderBottomRightRadius: '0.375rem'
     }}
    />
    <Card.Body className="position-relative fs--1">
     {errors.logo && <IconAlert variant="warning">{errors.logo.message}!</IconAlert>}
     <Flex wrap="wrap" alignContent="center" alignItems="center" justifyContent="center" className="mb-0">
      <Avatar
       uploader
       size="5xl"
       src={watch('image')}
       mediaClass="img-thumbnail shadow-sm"
       propUploader={{
        multiple: false,
        classInput: 'logo',
        iconClass: 'me-3 fs-2 icon-item-lg',
        register: register('image', { required: 'El logo es requerido' }),
        onChange: img => {
         console.log(img, 'img');
         setValue('image', img, { shouldValidate: true, shouldTouch: true });
        }
       }}
      />
      <div className="flex-grow-1 border-md-start border-start-2 ms-md-3 ps-md-1">
       <Input
        type="text"
        errors={errors}
        name="name"
        placeholder="Nombre del producto"
        formGroupProps={{ className: 'p-2 my-3' }}
        formControlProps={{
         ...register('name', {
          required: true,
          validate: value => !/[^a-zA-Z0-9_-ñ Ñ]/g.test(value) || 'Existen caracteres invalidos',
          minLength: { value: 5, message: 'El nombre debe tener al menos 5 caracteres' }
         }),
         autoComplete: 'off'
        }}
       />

       <Input
        type="select"
        errors={errors}
        name="category"
        placeholder="Seleccione categoria"
        formGroupProps={{ className: 'p-2 my-3' }}
        options={[
         { value: 'medicina', label: 'medicina' },
         { value: 'bisuteria', label: 'bisuteria' },
         { value: 'lenceria', label: 'lenceria' },
         { value: 'alimentos', label: 'alimentos' }
        ]}
        formControlProps={{ ...register('category', { required: true }) }}
       />

       <Input
        type="selectMulti"
        name="amenities"
        errors={errors}
        placeholder="Seleccione las subcategorias"
        options={select?.options}
        formGroupProps={{ className: 'p-2 my-3' }}
        formControlProps={{
         ...register('amenities', { required: 'Debe especificar las amenidades del proyecto' }),
         isClearable: true,
         isMulti: true,
         closeMenuOnSelect: false,
         onChange: newValue => setValue('amenities', newValue.map(e => e.value) || []),
         onCreateOption: createOption,
         value: select?.amenities
        }}
       />

       <Input
        type="textarea"
        errors={errors}
        name="description"
        placeholder="Campo para descripcion (opcional)"
        formGroupProps={{ className: 'p-2 my-3' }}
        formControlProps={{ ...register('description', { required: true }), rows: 2 }}
       />
      </div>
     </Flex>
    </Card.Body>
   </Card>

   <Card className="bg-transparent border m-3 mb-6">
    <Background
     image={corner4}
     className="bg-card"
     style={{
      borderTopRightRadius: '0.375rem',
      borderBottomRightRadius: '0.375rem'
     }}
    />
    <Card.Body className="position-relative fs--1">
     <Row className="g-2">
      <Input
       type="text"
       errors={errors}
       name="price"
       placeholder="Precio sugerido x und"
       formGroupProps={{ as: Col, xs: { span: 8, offset: 0 } }}
       formControlProps={{
        ...register('price', {
         required: true,
         validate: value => !/[^0-9]/g.test(value) || 'Existen caracteres invalidos'
        }),
        autoComplete: 'off'
       }}
      />

      <Input
       type="text"
       errors={errors}
       name="stockBase"
       placeholder="Stock disponible"
       formGroupProps={{ as: Col, xs: { span: 4, offset: 0 } }}
       formControlProps={{
        ...register('stockBase', { required: true, validate: value => !/[^0-9]/g.test(value) || false }),
        autoComplete: 'off'
       }}
      />

      <Card className="bg-transparent border" as={Col} sm={{ span: 6, offset: 0 }}>
       <Card.Body className="position-relative fs--1">
        <Flex justifyContent="start" alignItems="center" wrap="wrap">
         <div className="flex-grow-1 text-truncate">
          <h5 className="mb-0 fs--1 text-capitalize"> Caja </h5>
          <small className="m-0 fs--2">unidades y precio</small>
         </div>
         <div className="d-flex justify-content-end m-0">
          <Form.Check
           type="switch"
           id="box"
           size="lg"
           onChange={e => setIsExpanded(prev => ({ ...prev, box: e.target.checked }))}
          />
         </div>
        </Flex>

        <Collapse in={isExpanded.box}>
         <div className="">
          <Row className="g-2">
           <Input
            type="text"
            errors={errors}
            name="box.price"
            placeholder="Precio de caja"
            formGroupProps={{ as: Col, xs: { span: 8, offset: 0 } }}
            formControlProps={{
             ...register('box.price', {
              required: true,
              validate: value => !/[^0-9]/g.test(value) || 'Existen caracteres invalidos'
             }),
             autoComplete: 'off'
            }}
           />

           <Input
            type="text"
            errors={errors}
            name="box.units"
            placeholder="uds"
            formGroupProps={{ as: Col, xs: { span: 4, offset: 0 } }}
            formControlProps={{
             ...register('box.units', { required: true, validate: value => !/[^0-9]/g.test(value) || false }),
             autoComplete: 'off'
            }}
           />
          </Row>
         </div>
        </Collapse>
       </Card.Body>
      </Card>

      <Card className="bg-transparent border" as={Col} sm={{ span: 6, offset: 0 }}>
       <Card.Body className="position-relative fs--1">
        <Flex justifyContent="start" alignItems="center" wrap="wrap">
         <div className="flex-grow-1 text-truncate">
          <h5 className="mb-0 fs--1 text-capitalize"> Sobre </h5>
          <small className="m-0 fs--2">unidades y precio</small>
         </div>
         <div className="d-flex justify-content-end m-0">
          <Form.Check
           type="switch"
           id="envelope"
           size="lg"
           onChange={e => setIsExpanded(prev => ({ ...prev, envelope: e.target.checked }))}
          />
         </div>
        </Flex>

        <Collapse in={isExpanded.envelope}>
         <div className="">
          <Row className="g-2">
           <Input
            type="text"
            errors={errors}
            name="envelope.price"
            placeholder="Precio de sobre"
            formGroupProps={{ as: Col, xs: { span: 8, offset: 0 } }}
            formControlProps={{
             ...register('envelope.price', {
              required: true,
              validate: value => !/[^0-9]/g.test(value) || 'Existen caracteres invalidos'
             }),
             autoComplete: 'off'
            }}
           />

           <Input
            type="text"
            errors={errors}
            name="envelope.units"
            placeholder="uds."
            formGroupProps={{ as: Col, xs: { span: 4, offset: 0 } }}
            formControlProps={{
             ...register('envelope.units', { required: true, validate: value => !/[^0-9]/g.test(value) || false }),
             autoComplete: 'off'
            }}
           />
          </Row>
         </div>
        </Collapse>
       </Card.Body>
      </Card>
     </Row>
    </Card.Body>
   </Card>
  </Form>
 );
};

// New.propTypes = { watch: PropTypes.func, setValue: PropTypes.func, register: PropTypes.func, errors: PropTypes.object };

export default New;
